// @flow
export { default } from './ProductCard';



// WEBPACK FOOTER //
// ./src/components/common/ProductCard/index.js